import gql from 'graphql-tag'

const ShippingInstructionEdit = gql`
  mutation (
    $id: ID!,
    $comment1: String,
    $comment2: String
  ) {
    shippingInstructionEdit(
      id: $id,
      comment1: $comment1,
      comment2: $comment2
    )
}`

const ShippingInstructionDelete = gql`
  mutation($id: ID!) {
    shippingInstructionDelete(id: $id)
  }
`
const ShippingInstructionCreateOrder = gql`
  mutation shippingInstructionCreateOrder($id: ID!) {
    shippingInstructionCreateOrder(id: $id)
  }
`

const ShippingInstructionUpdateDB = gql`
  mutation shippingInstructionUpdateDB {
    shippingInstructionUpdateDB
  }
`
export { ShippingInstructionDelete, ShippingInstructionCreateOrder, ShippingInstructionEdit, ShippingInstructionUpdateDB }
